import styled from 'styled-components';
import * as BreezeColors from '../../../styles/colors';
import { getAgentInitials } from '../../../utils/agentUtils';

// --- AgentInitialsIcon Component ---
import { jsx as _jsx } from "react/jsx-runtime";
const StyledInitialsFlex = styled.div.withConfig({
  displayName: "AgentInitialsIcon__StyledInitialsFlex",
  componentId: "lfygjr-0"
})(["display:flex;align-items:center;justify-content:center;border-radius:", "px;background-color:", ";block-size:", ";inline-size:", ";margin-block-end:", ";min-block-size:", ";min-inline-size:", ";position:relative;"], props => props.borderRadius, props => props.background === 'gradient' ? BreezeColors.MAGENTA[100] : 'transparent', props => props.background === 'gradient' ? props.size : 'auto', props => props.size, ({
  theme,
  marginBlockEnd
}) => theme.space[marginBlockEnd || '400'], props => props.background === 'gradient' ? props.size : '14px', props => props.size);
const StyledInitialsText = styled.span.withConfig({
  displayName: "AgentInitialsIcon__StyledInitialsText",
  componentId: "lfygjr-1"
})(["position:relative;background:linear-gradient(135deg,", ",#fb31a7);background-clip:text;color:transparent;font-weight:600;font-size:", ";margin:0;line-height:1;"], BreezeColors.ORANGE[300], props => props.size);
export const AgentInitialsIcon = ({
  agentName,
  marginBlockEnd,
  size,
  borderRadius,
  background = 'gradient'
}) => {
  const initials = getAgentInitials(agentName);
  const numericalSize = size || 48;
  const containerSize = `${numericalSize}px`;
  const textSize = `${numericalSize / 2 - 1}px`;
  return /*#__PURE__*/_jsx(StyledInitialsFlex, {
    borderRadius: borderRadius,
    size: containerSize,
    marginBlockEnd: marginBlockEnd,
    background: background,
    children: /*#__PURE__*/_jsx(StyledInitialsText, {
      size: textSize,
      children: initials
    })
  });
};